export default "__VITE_ASSET__311ce888__"